module.exports = __webpack_public_path__ + "img/examine_model.7cd2defe.png";